<template>
  <div>
    <slot
      v-if="list !== null && list.length > 0"
      :list="list"
    >
    </slot>

    <p v-if="message !== null">
      {{message}}
    </p>

    <loading-indicator
      v-if="isLoading"
    />
  </div>
</template>

<script>
import { HTTP } from '../../http-common';
import notifier from '../../notifier';

import LoadingIndicator from '../LoadingIndicator.vue';

export default {
  name: 'ListBox',

  components: {
    LoadingIndicator,
  },

  props: {
    url: {
      type: String,
      required: true,
    },

    emptyListMessage: {
      type: String,
      required: true,
    },
  },

  computed: {
    message() {
      if(this.list !== null && this.list.length === 0) {
        return this.emptyListMessage;
      }
      return null;
    },
  },

  data() {
    return {
      isLoading: false,
      list: null,
    };
  },

  created() {
    this.loadList();
  },

  methods: {
    loadList() {
      notifier.deleteSenderNotifications(this);

      this.isLoading = true;

      HTTP.get(this.url)
      .then(response => {
        this.isLoading = false;

        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        this.list = data;
      })
      .catch(e => {
        this.isLoading = false;
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },
};
</script>
